<div class="gray-font-color font-family display-text full-height-vh">
  <div class="header-navigation-back">
    <span class="title">Drivers License Scan</span>
    @if (mobile) {
      <button  mat-icon-button (click)="onOpenActionSheet()">
        <mat-icon aria-hidden="false" aria-label="Identity actions">more_horiz</mat-icon>
      </button>
    }
  </div>
  @if (status) {
    <app-status-banner [status]="status" class="padding-bottom-xlg"> </app-status-banner>
  }
  @if (!mobile) {
    <div class="txt">
      @if (!mobile) {
        <div class="scan">
          <p>Scan one of the QR code below to make the switch</p>
        </div>
      }
      @if (!mobile) {
        <div class="qr-div margin-bottom-xlg"  fxLayoutGap="180px" alt="Responsive">
          <div >
            <img [src]="iOSAppQR" class="ios-qrcode-img" alt="Responsive image" />
            <img [src]="appStoreIcon" class="app-store" alt="Responsive image" />
          </div>
          <div>
            <img [src]="qrImg" class="qrcode-img" alt="Responsive image" />
          </div>
        </div>
      }
    </div>
  }
  @if (mobile && !error) {
    <div class="txt full-height-vh capture-container">
      @if (!error && finalImageFiles?.length != 2) {
        <div  class="video-container">
          <video
            [class.show]="!isCaptured"
            [class.hide]="isCaptured"
            #video
            id="video"
            [width]="WIDTH"
            [height]="HEIGHT"
            autoplay
            playsinline
          ></video>
          <canvas class="canvasClass hidden" #canvas id="canvas" [width]="WIDTH" [height]="HEIGHT"></canvas>
          <div class="" fxLayoutGap.lt-md="5px">
            @if (showCrop) {
              <div [ngClass]="{ 'image-cropper-container': !loading, 'no-height': loading }">
                <image-cropper
                  #previewImage
                  [imageBase64]="imageChangedEvent"
                  [maintainAspectRatio]="false"
                  [imageQuality]="100"
                  cropperMinWidth="420"
                  cropperMinHeight="220"
                  [roundCropper]="false"
                  [canvasRotation]="canvasRotation"
                  [transform]="transform"
                  format="png"
                  (imageCropped)="onImageCropped($event)"
                  (imageLoaded)="onImageLoaded()"
                  (cropperReady)="onCropperReady()"
                  (loadImageFailed)="onLoadImageFailed()"
                  >
                </image-cropper>
              </div>
            }
            @if (!loading && showCrop) {
              <div class="save-button-container full-width padding-top-x1">
                <div  class="margin-bottom-xlg">
                  <button
                    class="margin-bottom secondary-button"
                    mat-raised-button
                    (click)="onCancelCrop()"
                    data-test="finish-button"
                    [disabled]="isApiLoading"
                    >
                    Retake
                  </button>
                  <button mat-raised-button class="rotate-icons" (click)="rotateLeft()">
                    <mat-icon>rotate_left</mat-icon>
                  </button>
                  <button mat-raised-button class="rotate-icons" (click)="rotateRight()">
                    <mat-icon>rotate_right</mat-icon>
                  </button>
                  <button
                    class="margin-bottom  finish-crop-button"
                    mat-raised-button
                    (click)="onFinishCrop()"
                    data-test="finish-button"
                    [disabled]="isApiLoading"
                    >
                    Finish
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (finalImageFiles?.length == 2) {
        <div  class="text-align-center" fxLayoutGap="4px">
          <div >
            <img [src]="frontImageUrl" class="license-image" />
          </div>
          <div >
            <img [src]="backImageUrl" class="license-image" />
          </div>
        </div>
      }
      @if (finalImageFiles?.length != 2 && !showCrop) {
        <div  class="image-action-row">
          <div >
            <img [src]="frontImageUrl || 'assets/images/license-view-front.png'" class="preview-image" />
          </div>
          <div >
            <img [src]="backImageUrl || 'assets/images/license-view-back.png'" class="preview-image" />
          </div>
          @if (!isCaptured && finalImageFiles?.length != 2) {
            <button
              fxFlex="40"
              mat-button
              class="btn-proceed"
              (click)="capture()"
              [disabled]="isApiLoading"
              >
              Capture
            </button>
          }
        </div>
      }
      @if (finalImageFiles?.length == 2) {
        <div  class="image-action-row">
          <button mat-button class="btn-reset" (click)="resetLicense()" [disabled]="isApiLoading">
            Reset
          </button>
          <button mat-button class="btn-save" (click)="saveLicense()" [disabled]="isApiLoading">
            Save
          </button>
        </div>
      }
    </div>
  }
  @if (error) {
    <div class="video-error">{{ error }}. Please login again</div>
  }
</div>
